import loginSlice from "./loginSlice";

export default loginSlice.reducer;
export { default as loginSlice } from "./loginSlice";
export {
  setUserInfo,
  setTokenInfo,
  setTeamsContext,
  setTokenRefreshPreAction,
} from "./loginSlice";
